export default "<app-navigation></app-navigation>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"